function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("rect", {
  id: "Rectangle_3",
  "data-name": "Rectangle 3",
  width: 180,
  height: 67,
  transform: "translate(-0.333 -0.322)"
})), React.createElement("clipPath", {
  id: "clip-Artboard_4"
}, React.createElement("rect", {
  width: 180,
  height: 67
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Artboard_4",
  "data-name": "Artboard \\u2013 4",
  clipPath: "url(#clip-Artboard_4)"
}, React.createElement("g", {
  id: "Raptivity-2_1",
  "data-name": "Raptivity-2 \\u2013 1",
  transform: "translate(0.333 0.322)",
  clipPath: "url(#clip-path)"
}, React.createElement("g", {
  id: "Group_19",
  "data-name": "Group 19",
  transform: "translate(-0.021 14.338)"
}, React.createElement("g", {
  id: "Group_12",
  "data-name": "Group 12",
  transform: "translate(0 0)"
}, React.createElement("path", {
  id: "Path_21",
  "data-name": "Path 21",
  d: "M45.514,21.832s-14.9,2.691-14.741,9.507c0,0-1.9,9.035,44.855,13.155,0,0,46.437,3.9,83.212-1.435a103.793,103.793,0,0,0,25.2-5.866s-33.285,6.5-91.928,3.647c0,0-63.242-3.487-54.047-14.741C38.066,26.112,38.7,24.526,45.514,21.832Z",
  transform: "translate(-30.762 -6.56)",
  fill: "#02df82"
}), React.createElement("g", {
  id: "Group_3",
  "data-name": "Group 3",
  transform: "translate(19.897 0)"
}, React.createElement("path", {
  id: "Path_22",
  "data-name": "Path 22",
  d: "M71.011,31.243c.475.583.219,1.132-.547,1.132H65.789a1.274,1.274,0,0,1-1.132-.547l-6.219-7.851H56.187v7.485a.827.827,0,0,1-.913.913H51.258a.827.827,0,0,1-.913-.913V7.728a.827.827,0,0,1,.913-.913H60.2a8.741,8.741,0,0,1,8.762,8.766A8.452,8.452,0,0,1,64.439,22.9L71,31.241ZM56.187,18.864H60.2a3.094,3.094,0,0,0,2.922-3.283A3.094,3.094,0,0,0,60.2,12.3H56.187Z",
  transform: "translate(-50.34 -6.81)",
  fill: "#0c60b6"
}), React.createElement("path", {
  id: "Path_23",
  "data-name": "Path 23",
  d: "M89.407,20.764V31.348a.827.827,0,0,1-.913.913H84.987a.827.827,0,0,1-.913-.913v-.522a5.774,5.774,0,0,1-4.71,1.946,5.706,5.706,0,1,1,0-11.392,7.419,7.419,0,0,1,4.71,1.392V21.123c0-1.794-.73-2.594-2.264-2.594a2.153,2.153,0,0,0-2.118,1.058c-.219.511-.4.8-.949.8H75.166a.823.823,0,0,1-.913-.951c.475-3.946,3.833-5.952,7.559-5.952C85.826,13.5,89.407,15.841,89.407,20.764ZM84.076,27.08c0-1.132-.987-1.826-2.775-1.826-1.679,0-2.483.766-2.483,1.826s.8,1.826,2.483,1.826c1.788,0,2.773-.766,2.773-1.826Z",
  transform: "translate(-49.968 -6.702)",
  fill: "#0c60b6"
}), React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M114.423,23.138a9.166,9.166,0,0,1-8.727,9.64,6.861,6.861,0,0,1-5.44-2.217v8.1a.827.827,0,0,1-.913.913h-3.65a.827.827,0,0,1-.913-.913V14.923a.827.827,0,0,1,.913-.913h3.65a.827.827,0,0,1,.913.913v.793A6.861,6.861,0,0,1,105.7,13.5a9.168,9.168,0,0,1,8.727,9.64Zm-5.476,0a4.346,4.346,0,1,0-8.689,0,4.346,4.346,0,1,0,8.689,0Z",
  transform: "translate(-49.609 -6.702)",
  fill: "#0c60b6"
}), React.createElement("path", {
  id: "Path_25",
  "data-name": "Path 25",
  d: "M128.831,15.006v3.433a.827.827,0,0,1-.913.913h-2V31.438a.827.827,0,0,1-.911.913h-3.652a.827.827,0,0,1-.913-.913V19.352h-2.007a.827.827,0,0,1-.913-.913V15.006a.827.827,0,0,1,.913-.913h2.007V9.165a.827.827,0,0,1,.913-.913h3.652a.827.827,0,0,1,.911.913v4.929h2.009a.827.827,0,0,1,.9.911Z",
  transform: "translate(-49.232 -6.787)",
  fill: "#0c60b6"
}), React.createElement("path", {
  id: "Path_26",
  "data-name": "Path 26",
  d: "M133.32,31.343V14.912a.827.827,0,0,1,.913-.913h3.65a.827.827,0,0,1,.913.913V31.343a.827.827,0,0,1-.913.913h-3.65a.827.827,0,0,1-.913-.913Z",
  transform: "translate(-48.977 -6.692)",
  fill: "#0c60b6"
}), React.createElement("path", {
  id: "Path_27",
  "data-name": "Path 27",
  d: "M161.09,15.056l-5.952,16.467a1.019,1.019,0,0,1-1.022.73H150.17a1.019,1.019,0,0,1-1.022-.73L143.2,15.056c-.219-.658.109-1.058.768-1.058h3.907a.985.985,0,0,1,1.022.766l3.25,10.47,3.25-10.47A.985.985,0,0,1,156.416,14h3.946C161.015,14,161.309,14.4,161.09,15.056Z",
  transform: "translate(-48.814 -6.69)",
  fill: "#0c60b6"
}), React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M165.29,31.341V14.91a.827.827,0,0,1,.92-.908h3.65a.827.827,0,0,1,.913.913V31.346a.827.827,0,0,1-.913.913h-3.65a.827.827,0,0,1-.92-.918Z",
  transform: "translate(-48.452 -6.69)",
  fill: "#0c60b6"
}), React.createElement("path", {
  id: "Path_29",
  "data-name": "Path 29",
  d: "M186.666,15.006v3.433a.827.827,0,0,1-.913.913h-2.007V31.438a.827.827,0,0,1-.913.913H179.18a.827.827,0,0,1-.913-.913V19.352H176.26a.827.827,0,0,1-.913-.913V15.006a.827.827,0,0,1,.913-.913h2.007V9.165a.827.827,0,0,1,.913-.913h3.652a.827.827,0,0,1,.913.913v4.929h2.007a.827.827,0,0,1,.913.911Z",
  transform: "translate(-48.286 -6.787)",
  fill: "#0c60b6"
}), React.createElement("path", {
  id: "Path_30",
  "data-name": "Path 30",
  d: "M202.753,14H206.7c.658,0,.987.359.768,1.022L199.574,38.83a.994.994,0,0,1-1.058.73H194.57c-.656,0-.987-.359-.766-1.021l2.19-6.572-6.425-16.906c-.219-.621.074-1.058.73-1.058h3.946a1.021,1.021,0,0,1,1.022.73l3.467,9.677,2.994-9.64a.983.983,0,0,1,1.024-.77Z",
  transform: "translate(-48.051 -6.688)",
  fill: "#0c60b6"
})), React.createElement("rect", {
  id: "Rectangle_5",
  "data-name": "Rectangle 5",
  width: 5.476,
  height: 5.112,
  rx: 0.898,
  transform: "translate(104.242 0.005)",
  fill: "#02df82"
}), React.createElement("rect", {
  id: "Rectangle_6",
  "data-name": "Rectangle 6",
  width: 5.476,
  height: 5.112,
  rx: 0.898,
  transform: "translate(136.736 0.005)",
  fill: "#02df82"
})))));
var SvgLogoNew = function SvgLogoNew(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 180,
    height: 67,
    viewBox: "0 0 180 67",
    ref: svgRef
  }, props), _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_new.204b6aeb.svg";
export { ForwardRef as ReactComponent };